import { render, staticRenderFns } from "./TableSubHead.vue?vue&type=template&id=37de7192&"
import script from "./TableSubHead.vue?vue&type=script&lang=js&"
export * from "./TableSubHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37de7192')) {
      api.createRecord('37de7192', component.options)
    } else {
      api.reload('37de7192', component.options)
    }
    module.hot.accept("./TableSubHead.vue?vue&type=template&id=37de7192&", function () {
      api.rerender('37de7192', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/performance-evaluation/TableSubHead.vue"
export default component.exports